import { useTheme } from '../ThemeContext'

export default function DialogWrapper( { id, children } ) {
   
    let darkTheme = useTheme()

    const styles = {
        backgroundColor : darkTheme ? 'rgb(110 125 140)' : 'rgb(245, 245, 245)',
        color: darkTheme ? '#eee' : '#111',
    } 
    return (
        <dialog
            id={id}
            style={styles}
            className='font-quicksand text-center text-2xl bg-green-50 rounded-xl 
            shadow-lg border-4 border-gray-800 w-full p-8'
        >
            {children}
        </dialog>
    )
}
